import { useCallback, useEffect, useState } from 'react';

export type TppFlashVariant = 'success' | 'danger';

type FlashState = { message: string; variant: TppFlashVariant } | null;

/**
 * ページ上部のフィードバック。
 * 成功は自動消去、エラーは閉じるまで残す。
 */
export function useTppFlashMessage(autoHideMs = 5000) {
  const [flash, setFlash] = useState<FlashState>(null);

  useEffect(() => {
    if (!flash || flash.variant !== 'success') return;
    requestAnimationFrame(() => {
      document.getElementById('tpp-flash')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
    const timer = window.setTimeout(() => setFlash(null), autoHideMs);
    return () => window.clearTimeout(timer);
  }, [flash, autoHideMs]);

  const clearFlash = useCallback(() => setFlash(null), []);
  const setFlashMessage = useCallback(
    (message: string | null) => setFlash(message ? { message, variant: 'success' } : null),
    []
  );
  const setFlashError = useCallback(
    (message: string | null) => setFlash(message ? { message, variant: 'danger' } : null),
    []
  );

  return {
    flashMessage: flash?.message ?? null,
    flashVariant: flash?.variant ?? 'success',
    setFlashMessage,
    setFlashError,
    clearFlash,
  };
}
